import Masonry from "react-masonry-css";
import styled from "styled-components";

const MasonryGrid = styled(Masonry)`
  &.my-masonry-grid {
    display: flex;
    width: 100%;

    div {
      &.my-masonry-grid_column {
        box-sizing: border-box;
        padding: 0 1.5px;
        background-clip: padding-box;
      }
    }
  }
`;

interface Props {
  children: React.ReactNode;
  variant?: "narrow";
}

const CreatorPostsGrid = (props: Props) => {
  let breakpoints = {
    default: 5,
    2200: 5,
    1920: 4,
    1600: 4,
    1280: 3,
    900: 3,
    500: 2,
  };

  // used in modals
  if (props.variant && props.variant === "narrow") {
    breakpoints = {
      default: 4,
      2200: 4,
      1920: 4,
      1600: 4,
      1280: 4,
      900: 3,
      500: 2,
    };
  }

  return (
    <MasonryGrid
      breakpointCols={breakpoints}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
    >
      {props.children}
    </MasonryGrid>
  );
};

export default CreatorPostsGrid;
